module.exports = __webpack_public_path__ + "img/o-forcado.498db714.jpg";